import React from 'react'
import { CustomDatePicker } from '../../../../../../widgets/components/Datepicker'

interface ListHeaderProps {
  dateRange: { startDate: Date | null; endDate: Date | null }
  onDateChange: (dates: [Date | null, Date | null]) => void
  agent: string
  campaign: string
  status: string
  onAgentChange: (queue: string) => void
  onCampaignChange: (queue: string) => void
  onStatusChange: (queue: string) => void
  search: string
  onSearchChange: (value: string) => void
  onFilter: () => void
  onClear: () => void
  onExport: () => void
  agents: Array<{extension: number, nama: string }>
  campaigns: Array<{ name: string }>
  itemsPerPage: number
  onItemsPerPageChange: (itemsPerPage: number) => void
}

const ListHeader: React.FC<ListHeaderProps> = ({
  dateRange,
  onDateChange,
  agent,
  campaign,
  status,
  onAgentChange,
  onCampaignChange,
  onStatusChange,
  search,
  onSearchChange,
  onFilter,
  onClear,
  onExport,
  agents,
  campaigns,
  itemsPerPage,
  onItemsPerPageChange,
}) => {

  let isAgentOnly = false
  let currentAgentName = ''

  try {
    const raw = localStorage.getItem('kt-auth-react-v')
    if (raw) {
      const parsed = JSON.parse(raw)
      currentAgentName = parsed.name || ''
      const roles = parsed.roles || []
      isAgentOnly = roles.includes('ROLE_AGENT')
    }
  } catch (e) {
    console.error('Error reading auth state inside ListHeader', e)
  }

  return (
    <>
      {/* Header Title */}
      <div className='glass-card monitoring-header position-relative'>
        <h1>Outbound Call Recording</h1>
        <p>Automatically records all outgoing calls for quality assurance, auditing, training, and communication verification.</p>
        <div className='connection-status-indicator connected'>
          <span className='indicator-dot' style={{ animation: 'pulse-glow 2s infinite' }} />
          System Online
        </div>
      </div>
      

      {/* Search + Filter Container */}
      <div className='glass-card search-filter-container'>
        <div className='row g-3 align-items-center p-3'>
          
          <div className={isAgentOnly ? 'col-md-5' : 'col-md-4'}>
            <div className='input-group'>
              <span className='input-group-text'>
                <i className='bi bi-search'></i>
              </span>
              <input
                type='text'
                className='form-control modern-search-input'
                placeholder='Search...'
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          </div>

          {!isAgentOnly && (
            <>
              <div className='col-md-3'>
                <CustomDatePicker dateRange={dateRange} onDateChange={onDateChange} />
              </div>
              <div className='col-md-2'>
                <select
                  className='form-select'
                  value={isAgentOnly ? currentAgentName : agent}
                  onChange={(e) => onAgentChange(e.target.value)}
                  disabled={isAgentOnly}
                >
                  {!isAgentOnly && <option value=''>All Agent</option>}
                  
                  {agents.map((q, index) => (
                    <option key={q.extension ? q.extension : `agent-${index}`} value={q.nama || ''}>
                      {q.extension || 'No Ext'} - {q.nama}
                    </option>
                  ))}
                </select>
              </div> 
            </>
          )}
          
          <div className={isAgentOnly ? 'col-md-2' : 'col-md-1'}>
            <select
              className='form-select'
              value={status}
              onChange={(e) => onStatusChange(e.target.value)}
            >
              <option value=''>All Status</option>
              <option key={'ANSWERED'} value={'ANSWERED'}>ANSWERED</option>
              <option key={'NO ANSWER'} value={'NO ANSWER'}>NO ANSWER</option>
              <option key={'FAILED'} value={'FAILED'}>FAILED</option>
              <option key={'BUSY'} value={'BUSY'}>BUSY</option>
            </select>
          </div>

          <div className='col-md-1'>
            <select
              className='form-select'
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>

          <div className='col-md-2 d-flex gap-1'>
            <button className='btn-hover-effect btn-warning' onClick={onClear}>
              <i className='bi bi-x-circle-fill'></i> Clear
            </button>

            <button className='btn-hover-effect btn-success' onClick={onExport}>
              <i className='bi bi-file-earmark-excel-fill'></i>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export { ListHeader }